// extracted by mini-css-extract-plugin
export var avatarContainer = "_7s-0";
export var avatarTypingWave = "_7s-i";
export var gray = "_7s-f";
export var green = "_7s-c";
export var icon = "_7s-9";
export var image = "_7s-1";
export var lg = "_7s-6";
export var md = "_7s-5";
export var presenceDot = "_7s-b";
export var red = "_7s-d";
export var sm = "_7s-4";
export var status = "_7s-a";
export var typingDot = "_7s-h";
export var typingPill = "_7s-g";
export var xl = "_7s-7";
export var xs = "_7s-3";
export var xxl = "_7s-8";
export var xxs = "_7s-2";
export var yellow = "_7s-e";